import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import brandAPI from "../../api/brandApi";
import BrandCard from "../brands/Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");

  useEffect(() => {
    fetchBrand();
  }, []);

  const fetchBrand = async () => {

    try {
      const res = await brandAPI.listing();

      if (res.code === 200) {
        const { brands, totalCount } = res.data;

        setItems(brands);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  return (
    <>
      <Breadcrump title="Brand" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">
          <div className="blog-count text-left mb-4">
            Total: <b>{totalCount}</b> brand
          </div>

          {items && items.length > 0 && (
            <div className="row   g-4">
              {items.map((item, index) => (
                <div className="col-md-2" key={index}>
                  <BrandCard item={item} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;
